import { i18n } from "../src/plugins/i18n";

const content = {
  page_title: "Report",
  devices_table: [
    {
      text: i18n.t("components.PowerDataMainReport.tables.devices.columns.name.text"),
      value: "DeviceName",
      sortable: true,
      of_type: "link",
      identifier: "DeviceID",
      url: "/asset/",
    },
    {
      text: i18n.t("components.PowerDataMainReport.tables.devices.columns.transformerSize.text"),
      value: "PowerRating",
      of_type: "number",
      suffix: "kVA",
      decimal: -1,
    },
    {
      text: "Max Apparent Power L1-L2-L3",
      value: "MaxApparentPower",
      of_type: "multi",
      values: ["L1_ApparentPowerMax", "L2_ApparentPowerMax", "L3_ApparentPowerMax"],
      decimal: -1,
      suffix: "kVA",
    },
    {
      text: i18n.t("components.PowerDataMainReport.tables.devices.columns.maxCurrent.text"),
      value: "Current0Max",
      of_type: "multi",
      values: ["Current0Max", "Current1Max", "Current2Max"],
      decimal: -1,
      suffix: "A",
    },
    {
      text: "Loss of Main",
      value: "loss_of_main",
      of_type: "text",
    },
  ],
  issues_table: [
    {
      align: "start",
      text: "Subject",
      value: "issue",
      of_type: "text",
    },
    {
      text: i18n.t("components.PowerDataMainReport.tables.fleetStatus.columns.numberOfAssets.text"),
      value: "totalDevices",
      of_type: "text",
    },
    {
      text: i18n.t("components.PowerDataMainReport.tables.fleetStatus.columns.percentageDevices.text"),
      value: "percentageDevices",
      of_type: "text",
    },
  ],
  fleet_overview_items: [
    { id: "devices_installed", label: "Devices Installed" },
    { id: "ground_mounts", label: "Ground Mounts" },
    { id: "pole_mounts", label: "Pole Mounts" },
    { id: "number_of_1000", label: "Number of 1000 kVA" },
    { id: "number_of_630", label: "Number of 630 kVA" },
    { id: "number_of_400", label: "Number of 400 kVA" },
    { id: "loss_of_main", label: "Loss of Main" },
  ],
};

export { content };
